import Editor from "./Editor";
import Request from './Request.utils';
import * as Api from './api';

class PrintManagerClient {

  setHost(v: string) {
    Request.setHost(v);
  }
  setToken(v: string) {
    Request.setToken(v);
  }
  getToken = () => Request.getToken();

  editor = new Editor(this);

  Api=Api
}

export * from './type';

export default new PrintManagerClient();